import { groupLifeService } from '@/services';
import { downloadFromSignedUrl } from '@/shared/utils/signed-url.util';
import { useMutation } from '@tanstack/react-query';

/**
 * Baixa o PDF de análise de crédito do estipulante (WI 2224).
 *
 * É mutation, não query: cada chamada GERA um relatório novo no backend — a
 * cotação pode ter sido recalculada, e servir um PDF em cache levaria o
 * subscritor a decidir sobre números velhos. Por isso também não há
 * `queryKey` a invalidar.
 */
export function useGroupLifeCreditAnalysisPdf() {
  return useMutation({
    mutationFn: async (policyId: string) => {
      const response = await groupLifeService.getCreditAnalysisPdf(policyId);

      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao gerar o relatório de crédito'
        );
      }

      // A API manda o nome com o número da cotação (P930016…). O fallback
      // usa só a parte numérica do PolicyId: o id assinado tem vírgula e hash.
      await downloadFromSignedUrl(
        response.data.url,
        response.data.fileName ??
          `analise-credito-${policyId.split(',')[0]}.pdf`
      );

      return response.data;
    },
  });
}
